<section class="box-header">
    <div
        class="fixed-box-header"
        [ngStyle]="{'background-color': color, 'z-index': zIndex}"
    >
        <ng-template
            [ngIf]="!isShowCustomContent"
            [ngIfElse]="custom_content"
        >
            <div class="header-title">
                <span
                    *ngIf="!hasContent && title"
                    [textContent]="title"
                ></span>
            </div>
            <div class="header-link">
                <ng-content select="[slot=custom-icon]"></ng-content>
                <navaar-chevron-icon
                *ngIf="showBackIcon"
                    (click)="goBack()"
                    [style]="{
                                width: '18px',
                                float: 'left',
                                height: '18px'
                            }"
                ></navaar-chevron-icon>
            </div>
        </ng-template>
        <ng-template #custom_content>
            <ng-content></ng-content>
        </ng-template>
    </div>
</section>
